import { useState } from 'react';
import style from './TextInput.module.css';

const NumberInput = ({ name, value, title, onChange, placeholder, id, className }) => {
  const [ numErr, setNumErr] = useState('')

 const handleNumberChange = (event) => {
  setNumErr('');
  const val = event.target.value;
  if (/^\d*\.?\d*$/.test(val)) {
    onChange?.(event);
  } else {
    setNumErr("Only numeric input is allowed (including decimals)");
  }
};
  

  return (
    <>
      <div className={`${className || ''} ${style.cover}`}>
        {title && <label htmlFor={id}>{title}</label>}
        <input
          type="text"
          name={name}
          value={value}
          id={id}
          placeholder={placeholder}
          onChange={handleNumberChange}
          className={style.textInput}
        />
      </div>
      {numErr ? <p style={{marginBottom: 20}} className='error'>{numErr}</p> : null}
    </>
  );
};

export default NumberInput;
